import React, { Component, PropTypes } from 'react';

import css from './errorToaster.scss';

//import fwaLogo from './fwa-logo.png';
//import BurgerIcon from './burger.png';
//import BurgerIconClose from './burger-close.png';
//import Burger from 'babel!svg-react!./burger.svg?name=Burger';

export default class ErrorToaster extends Component {
	static propTypes = {
		error: PropTypes.bool,
		message: PropTypes.string,
		show: PropTypes.bool,
		clearErrors: PropTypes.func,
	};

	static defaultProps = {
		error: false,
		message: '',
		show: false,
		clearErrors: function() {},
	};

	constructor(props) {
		super(props);

		this.timer = 0;

		this.state = {
			msg: '',
			show: false,
			error: false,
		};
	}

	componentDidUpdate() {}

	componentWillReceiveProps(nProps, nState) {
		if (
			nProps.show &&
			this.props.message !== nProps.message
		) {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.props.clearErrors();
			}, 8000);
		}

		this.setState({
			msg: nProps.message,
			show: nProps.show,
			error: (nProps.show ? nProps.error : this.state.error),
		});
	}

	render() {
		return (
			<div className={'error-toaster' + (this.state.show ? ' error-toaster--show' : '') + (this.state.error ? ' error-toaster--error' : '')}>
				<div className='error-toaster__shift'>
					{this.state.msg}
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/header/errorToaster/errorToaster.js
 **/